import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ParkingIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.8466 5C13.7746 5 14.6032 5.20549 15.3324 5.61648C16.0616 6.01421 16.625 6.56439 17.0227 7.26705C17.4337 7.9697 17.6392 8.75189 17.6392 9.61364C17.6392 10.4621 17.4403 11.2377 17.0426 11.9403C16.6449 12.6297 16.0814 13.1799 15.3523 13.5909C14.6231 13.9886 13.7879 14.1875 12.8466 14.1875H10.0028V19H7V5H12.8466ZM12.4489 11.642C12.8466 11.642 13.1979 11.5559 13.5028 11.3835C13.821 11.2112 14.0663 10.9725 14.2386 10.6676C14.411 10.3494 14.4972 9.99811 14.4972 9.61364C14.4972 9.24242 14.4044 8.91099 14.2187 8.61932C14.0464 8.31439 13.8011 8.08239 13.483 7.9233C13.178 7.75095 12.8333 7.66477 12.4489 7.66477H10.0028V11.642H12.4489Z" />
    </SvgIcon>
  );
});
